<div class="alert alert-success" role="alert" *ngIf="healthCheck!=''">
    {{ healthCheckStatus }}
</div>

<div class="alert alert-warning" role="alert" *ngIf="healthCheck==''">
    {{ healthCheckStatus }}
</div>